import { store } from '@/decorators/store';
import { RequestCancellationReasons } from '@/entities/RequestCancellationReasons';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';

@store({ id: 'RequestCancellationReasonsStore' })
export class RequestCancellationReasonsStore extends AbstractEntityStore<RequestCancellationReasons> {
  protected entityIdKey = 'cancelReasonId';
  protected entityValueKey = 'cancelReason';
}
